import React from 'react';
// import CustomNavbar from '../components/common/CustomNavbar'; // Import the Navbar component
// import Footer from '../components/common/Footer';

import './cardiology.css'; // Import the CSS file for styling

import bg2 from '../assets/img/bg-2 1.png';
import pngwing from '../assets/img/pngwing.png';
import department14 from '../assets/img/departments-5 5 (3).png';
import department13 from '../assets/img/departments-5 4 (2).png';

const Cardiology = () => {
  return (
    <>
      {/* <CustomNavbar /> */}
      <div className="CA-content">
        <h1 className="CA-nav-heading">Cardiology</h1>
        <p className="CA-paragraph1">
        Comprehensive Revenue Cycle Management (RCM) Services by RDS
        </p>
      </div>
     
      <div className="CA-overlay-content1">
          <h1 className="CA-heading44">
            <span className="CA-heading-part11">Chat with our care team <br/> anytime</span>
            <span className="CA-heading-part22"> you need to</span>
          </h1>
          <p className="CA-paragraph2014">
          To be an exemplary healthcare provider, alignment with the organization's  <br/>  values and vision, along with the necessary resources for effective delivery, is  <br/>  crucial. RDS Precision stands as the optimal tool and service for maximizing the  <br/>  profitability of your practice. With over six years of demonstrated expertise,  <br/>  Carevma is a trusted partner for complex health systems
          </p>
         
        </div>
        {/* <div className='CA-button'>
        <button className="CA-cta-button">Read More</button>
        </div> */}
        <img src={department13} alt="Your Image" className="CA-dp-image1" />
      

          <div className="CA-image-container2">
        <img src={bg2} alt="description" className="CA-my-image1" />
        <div className="CA-overlay-content1">
          <h1 className="CA-heading4">
            <span className="CA-heading-part11">Our mission is to streamline the <br/> revenue cycle so physicians can <br/>focus on high-quality care and <br/> </span>
            <span className="CA-heading-part221">patient satisfaction.</span>
          </h1>
          <p className="CA-paragraph201">
          We specialize in International Cardiology, offering precise medical <br/>coding, meticulous billing, and effective collection strategies to <br/> enhance revenue.
          </p>
        </div>
        <img src={department14} alt="Your Image" className="CA-dp-image2" />
        </div>
        <div className="CA-gradient-container">
          <img src={pngwing} alt="Your Image" className="CA-background-image" />
          <div className="CA-container-wrapper">
            <h2 className="CA-container-heading">Our services include:</h2>

            <div class="CA-container-wrapper">
 
 <div class="CA-container-item1">
   <div class="CA-checkbox-container">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="CA-content-container1">
     <p> Core billing services</p>
   </div>
 </div>
 <div class="CA-container-item1">
   <div class="CA-checkbox-container">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="CA-content-container1">
     <p> Core billing services</p>
   </div>
 </div>
 <div class="CA-container-item1">
   <div class="CA-checkbox-container">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="CA-content-container1">
     <p> Core billing services</p>
   </div>
 </div>
 <div class="CA-container-item1">
   <div class="CA-checkbox-container">
     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
       <path d="M16.0003 31.8337C7.25558 31.8337 0.166992 24.7451 0.166992 16.0003C0.166992 7.25558 7.25558 0.166992 16.0003 0.166992C24.7451 0.166992 31.8337 7.25558 31.8337 16.0003C31.8337 24.7451 24.7451 31.8337 16.0003 31.8337ZM16.0003 28.667C19.3597 28.667 22.5816 27.3325 24.957 24.957C27.3325 22.5816 28.667 19.3597 28.667 16.0003C28.667 12.6409 27.3325 9.4191 24.957 7.04364C22.5816 4.66818 19.3597 3.33366 16.0003 3.33366C12.6409 3.33366 9.4191 4.66818 7.04364 7.04364C4.66818 9.4191 3.33366 12.6409 3.33366 16.0003C3.33366 19.3597 4.66818 22.5816 7.04364 24.957C9.4191 27.3325 12.6409 28.667 16.0003 28.667ZM14.4217 22.3337L7.70366 15.6156L9.94249 13.3767L14.4217 17.856L23.3787 8.89907L25.6175 11.1379L14.4217 22.3337Z" fill="#076AFF"/>
     </svg>
   </div>
   <div class="CA-content-container1">
     <p> Core billing services</p>
   </div>
 </div>
          </div>
        </div>
        </div>
        <div className="CA-text-container">
  <h1 className="CA-text-heading">We develop sophisticated paid lifecycle solutions <br/> for healthcare providers, optimizing pre-<br/> authorization workflows across hospitals, clinics,<br/>  imaging centers, and laboratories</h1>
  <p className="CA-text-paragraph">OB/GYN professionals require a partner that understands their unique needs,<br/>  offering comprehensive support that spans from advanced reporting and <br/> analytics to efficient billing and precisely timed appointment scheduling._ _ is<br/>  dedicated to meeting these needs with a level of sophistication that sets a new <br/>  standard in the fieOur comprehensive suite of patient payment and medical<br/>  billing solutions is designed to expedite the billing collection process, enhance <br/>  cash flow, and effectively maintain revenue integrity across the entire payment <br/>  lifecycle.ld.</p>
</div>


  
     
    </>
  );
};

export default Cardiology;
